/**
 * Mini cart drawer: open/close/toggle, fetch cart, render items, quantity/remove.
 * Listens for gaurya:minicart:open (after AJAX add). Header cart click opens drawer.
 */
(function () {
  function formatMoney(cents, moneyFormat) {
    if (moneyFormat == null || moneyFormat === '') {
      return (cents / 100).toFixed(2);
    }
    moneyFormat = String(moneyFormat).replace(/\bRs\.?\s*/gi, '₹ ');
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/\./, ','));
  }

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var scrollPosition = 0;

  function openDrawer() {
    var drawer = document.getElementById('gaurya-minicart-drawer');
    var backdrop = document.getElementById('gaurya-minicart-backdrop');
    if (!drawer || !backdrop) return;

    /* Save scroll position before changing it so we can restore on close. */
    scrollPosition = window.scrollY;

    var header = document.querySelector('header.gaurya-navbar');
    if (header) {
      var offset = header.offsetHeight;
      document.documentElement.style.setProperty('--minicart-header-offset', offset + 'px');
    }

    /* Scroll to top so the navbar is in view; then the drawer’s top offset lines up with the visible header. */
    window.scrollTo(0, 0);

    document.body.style.position = 'fixed';
    document.body.style.top = '0';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-open');

    fetchAndRenderCart();
    var firstFocus = drawer.querySelector('[data-gaurya-minicart-close]');
    if (firstFocus) firstFocus.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('gaurya-minicart-drawer');
    var backdrop = document.getElementById('gaurya-minicart-backdrop');
    if (!drawer || !backdrop) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    window.scrollTo(0, scrollPosition);
  }

  function toggleDrawer() {
    var drawer = document.getElementById('gaurya-minicart-drawer');
    if (drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  function updateHeaderCount(count) {
    var el = document.querySelector('[data-gaurya-cart-count]');
    if (!el) return;
    if (count > 0) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.style.display = 'flex';
    } else {
      el.style.display = 'none';
    }
  }

  /**
   * Updates drawer DOM from a cart JSON object (from cart.js or cart/change.js).
   * Does not show full-drawer loading or fetch. Hides loading if it was visible.
   */
  function renderCartFromObject(drawer, cart) {
    if (!drawer || !cart) return;
    var loading = drawer.querySelector('[data-gaurya-minicart-loading]');
    var empty = drawer.querySelector('[data-gaurya-minicart-empty]');
    var itemsContainer = drawer.querySelector('[data-gaurya-minicart-items]');
    var footerHasItems = drawer.querySelector('[data-gaurya-minicart-footer-has-items]');
    var footerEmpty = drawer.querySelector('[data-gaurya-minicart-footer-empty]');
    var subtotalEl = drawer.querySelector('[data-gaurya-minicart-subtotal]');
    var totalEl = drawer.querySelector('[data-gaurya-minicart-total]');
    var moneyFormat = drawer.getAttribute('data-money-format') || '';
    if (loading) {
      loading.setAttribute('aria-hidden', 'true');
      loading.style.display = 'none';
    }
    updateHeaderCount(cart.item_count || 0);
    var hasItems = cart.items && cart.items.length > 0;
    if (empty) {
      if (hasItems) {
        empty.classList.add('minicart-drawer__empty--hidden');
      } else {
        empty.classList.remove('minicart-drawer__empty--hidden');
      }
    }
    if (footerHasItems) {
      if (hasItems) {
        footerHasItems.classList.remove('minicart-drawer__footer-content--hidden');
      } else {
        footerHasItems.classList.add('minicart-drawer__footer-content--hidden');
      }
    }
    if (footerEmpty) {
      footerEmpty.style.display = hasItems ? 'none' : 'block';
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price || 0, moneyFormat);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price || 0, moneyFormat);
    if (!itemsContainer) return;
    itemsContainer.innerHTML = '';
    if (!hasItems) return;
    cart.items.forEach(function (item) {
      var node = renderItem(item, moneyFormat, drawer);
      if (node) itemsContainer.appendChild(node);
    });
  }

  function fetchAndRenderCart() {
    var drawer = document.getElementById('gaurya-minicart-drawer');
    if (!drawer) return;
    var loading = drawer.querySelector('[data-gaurya-minicart-loading]');
    var empty = drawer.querySelector('[data-gaurya-minicart-empty]');
    var itemsContainer = drawer.querySelector('[data-gaurya-minicart-items]');
    if (loading) {
      loading.removeAttribute('aria-hidden');
      loading.style.display = 'flex';
    }
    if (empty) empty.classList.add('minicart-drawer__empty--hidden');
    if (itemsContainer) itemsContainer.innerHTML = '';

    fetch(getRoot() + 'cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartFromObject(drawer, cart);
      })
      .catch(function () {
        if (loading) {
          loading.setAttribute('aria-hidden', 'true');
          loading.style.display = 'none';
        }
        if (empty) {
          empty.classList.remove('minicart-drawer__empty--hidden');
          var emptyText = empty.querySelector('.minicart-drawer__empty-text');
          if (emptyText) emptyText.textContent = 'Unable to load cart.';
        }
      });
  }

  function renderItem(item, moneyFormat, drawer) {
    var div = document.createElement('div');
    div.className = 'minicart-item';
    div.setAttribute('data-key', item.key);

    var imgUrl = item.image && item.image !== '' ? item.image : '';
    var title = item.product_title || item.title || 'Product';
    var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    variantTitle = variantTitle.replace(/\b5\s*L\b/gi, '5 litre');
    var price = item.final_line_price != null ? item.final_line_price : (item.line_price || item.price * item.quantity);
    var qty = item.quantity || 1;

    div.innerHTML =
      '<div class="minicart-item__image-wrap">' +
        (imgUrl
          ? '<img class="minicart-item__image" src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" width="100" height="100">'
          : '<div class="minicart-item__image" style="background: rgba(255,255,255,0.1); width: 100%; height: 100%;"></div>') +
      '</div>' +
      '<div class="minicart-item__content">' +
        '<div class="minicart-item__row">' +
          '<div>' +
            '<h3 class="minicart-item__title">' + escapeHtml(title) + '</h3>' +
            (variantTitle ? '<p class="minicart-item__variant">' + escapeHtml(variantTitle) + '</p>' : '') +
            '<p class="minicart-item__price gaurya-money">' + formatMoney(price, moneyFormat) + '</p>' +
          '</div>' +
          '<button type="button" class="minicart-item__remove" aria-label="Remove item" data-gaurya-minicart-remove data-key="' + escapeHtml(item.key) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="minicart-item__qty">' +
          '<button type="button" class="minicart-item__qty-btn" data-gaurya-minicart-qty-minus data-key="' + escapeHtml(item.key) + '">−</button>' +
          '<span class="minicart-item__qty-value" data-gaurya-minicart-qty-value>' + String(qty) + '</span>' +
          '<button type="button" class="minicart-item__qty-btn" data-gaurya-minicart-qty-plus data-key="' + escapeHtml(item.key) + '">+</button>' +
        '</div>' +
      '</div>';

    var removeBtn = div.querySelector('[data-gaurya-minicart-remove]');
    var minusBtn = div.querySelector('[data-gaurya-minicart-qty-minus]');
    var plusBtn = div.querySelector('[data-gaurya-minicart-qty-plus]');

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        changeQuantity(item.key, 0, drawer);
      });
    }
    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        changeQuantity(item.key, Math.max(0, qty - 1), drawer);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        changeQuantity(item.key, qty + 1, drawer);
      });
    }

    return div;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function showOverlay(drawer) {
    var overlay = drawer && drawer.querySelector('[data-gaurya-minicart-overlay]');
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    }
  }

  function hideOverlay(drawer) {
    var overlay = drawer && drawer.querySelector('[data-gaurya-minicart-overlay]');
    if (overlay) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  function changeQuantity(key, quantity, drawer) {
    showOverlay(drawer);

    var root = getRoot();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        hideOverlay(drawer);
        if (result.ok && result.data && result.data.items) {
          renderCartFromObject(drawer, result.data);
        } else {
          fetchAndRenderCart();
        }
      })
      .catch(function () {
        hideOverlay(drawer);
        fetchAndRenderCart();
      });
  }

  function init() {
    var drawer = document.getElementById('gaurya-minicart-drawer');
    var backdrop = document.getElementById('gaurya-minicart-backdrop');
    if (!drawer || !backdrop) return;

    var closeBtn = drawer.querySelector('[data-gaurya-minicart-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    document.addEventListener('gaurya:minicart:open', openDrawer);
    document.addEventListener('gaurya:cart:updated', function (e) {
      if (e.detail && typeof e.detail.item_count === 'number') {
        updateHeaderCount(e.detail.item_count);
      }
    });

    var toggleEl = document.querySelector('[data-gaurya-minicart-toggle]');
    if (toggleEl) {
      toggleEl.addEventListener('click', function (e) {
        e.preventDefault();
        toggleDrawer();
      });
    }

    var viewCartLink = drawer.querySelector('[data-gaurya-minicart-view-cart]');
    if (viewCartLink) {
      viewCartLink.addEventListener('click', closeDrawer);
    }

    var checkoutLink = drawer.querySelector('[data-gaurya-minicart-checkout]');
    if (checkoutLink) {
      checkoutLink.addEventListener('click', function (e) {
        e.preventDefault();
        var checkoutUrl = checkoutLink.getAttribute('href') || (getRoot() + 'checkout');
        fetch(getRoot() + 'cart.js')
          .then(function (res) { return res.json(); })
          .then(function () {
            window.location.href = checkoutUrl;
          })
          .catch(function () {
            window.location.href = checkoutUrl;
          });
      });
    }
  }

  window.GauryaMiniCart = {
    open: openDrawer,
    close: closeDrawer,
    toggle: toggleDrawer,
    refresh: fetchAndRenderCart
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
